import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", null, "New content is available! Please refresh.", -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _hoisted_1,
        _createElementVNode("button", {
            class: "pwa-update-notification__button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
            //@ts-ignore
            (...args) => ($setup.refresh && $setup.refresh(...args)), ["stop"]))
        }, " Refresh ")
    ]));
}
